﻿$.fn.dxCtrlTxtEmoji = function custom_dxCtrlTxtEmoji(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrltxtemoji dx-ctrl");
        this.createInstance(new cdxCtrlTxtEmoji(this, option));
    }
    return this;
}

window.cdxCtrlTxtEmoji = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = []

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            if (name == "label" || name == "labelMode" || name == "stylingMode") mRenderLabel()   // ← LABEL
        }
    }

    // ===================== ← LABEL : gestion du label façon DevExtreme =====================
    var CLASSES_LABEL = "dx-texteditor dx-editor-outlined dx-editor-filled dx-editor-underlined "
        + "dx-texteditor-with-label dx-texteditor-with-floating-label dx-texteditor-empty "
        + "dx-state-focused dx-state-hover";

    function mRenderLabel() {
        container.removeClass(CLASSES_LABEL);
        container.children(".dx-texteditor-label").remove();

        var mode = option.label ? (option.labelMode || "static") : "hidden";
        if (mode == "hidden") return;   // pas de label : rendu d'origine

        container
            .addClass("dx-texteditor dx-editor-" + (option.stylingMode || "outlined"))
            .addClass(mode == "floating" ? "dx-texteditor-with-floating-label" : "dx-texteditor-with-label");

        // Même structure que celle générée par dxTextBox
        var $label = $(
            "<div class='dx-texteditor-label'>" +
            "<div class='dx-label-before'></div>" +
            "<div class='dx-label'><span></span></div>" +
            "<div class='dx-label-after'></div>" +
            "</div>").appendTo(container);
        $label.find(".dx-label span").text(option.label);

        mMajLargeurLabel();
        mMajVide();
    }

    // DevExtreme limite la largeur du label en JS (sinon il déborde sur le bouton emoji)
    function mMajLargeurLabel() {
        var $label = container.find("> .dx-texteditor-label");
        if (!$label.length) return;
        var largeur = container.innerWidth()
            - $label.find(".dx-label-before").outerWidth()
            - 40;   // place du bouton emoji
        $label.find(".dx-label").css("max-width", Math.max(largeur, 0));
    }

    function mMajVide() {
        if (!container.hasClass("dx-texteditor")) return;
        var txt = $InputObjetEmoji ? $InputObjetEmoji.getText() : (option.value || "").toString();
        container.toggleClass("dx-texteditor-empty", $.trim(txt) == "");
    }

    function mSetFocus(b) {
        if (container.hasClass("dx-texteditor")) container.toggleClass("dx-state-focused", b);
    }
    // =======================================================================================

    this.isDirty = false
    var $InputObjetEmoji = null
    var emojiArreaInstance = null
    var lastCaret = null;

    function mConstruit() {
        container.empty();
        var $InputObjet = $("<input placeholder='" + (option.placeholder || "") + "'></input>").appendTo(container)
        $InputObjet.emojioneArea({
            pickerPosition: ((typeof option.pickerPosition == 'undefined') ? "top" : option.pickerPosition),
            value: option.value,
            tonesStyle: "bullet",
            searchPlaceholder: "Rechercher...",
            events: {
                blur: function (editor, event) {
                    var caretOffset = 0;
                    var doc = emojiArreaInstance.editor[0].ownerDocument;
                    var win = doc.defaultView;
                    var sel;
                    if (typeof win.getSelection != "undefined") {
                        sel = win.getSelection();
                        if (sel.rangeCount > 0) {
                            var range = win.getSelection().getRangeAt(0);
                            var preCaretRange = range.cloneRange();
                            preCaretRange.selectNodeContents(emojiArreaInstance.editor[0]);
                            preCaretRange.setEnd(range.endContainer, range.endOffset);
                            caretOffset = preCaretRange.toString().length;
                        }
                    }
                    lastCaret = caretOffset
                    mSetFocus(false)                                      // ← LABEL
                    mMajVide()                                            // ← LABEL
                },
                keyup: function (editor, event) {                         // ← LABEL
                    mMajVide()
                },
                "emojibtn.click": function (button, event) {             // ← LABEL
                    mMajVide()
                },
                keydown: function (editor, event) {
                    if (event.key === "Enter" && !event.shiftKey) {
                        event.preventDefault();
                        Me.isDirty = true;
                        option.value = Me.mGetValue();
                        if (typeof option.onValueChanged !== 'undefined') {
                            option.onValueChanged(option.value);
                        }
                    }
                },
                focus: function (editor, event) {
                    mSetFocus(true)                                       // ← LABEL
                    if (lastCaret != null) {
                        var range = document.createRange();
                        var sel = window.getSelection();
                        range.setStart(emojiArreaInstance.editor[0].childNodes[0] || emojiArreaInstance.editor[0], lastCaret);
                        range.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                },
                onLoad: function () {
                    Me.isDirty = false
                    var editor = this.editor;
                    emojiArreaInstance = this
                    window.setTimeout(function () {
                        $InputObjetEmoji = $InputObjet[0].emojioneArea
                        $InputObjetEmoji.setText(option.value)
                        mMajVide()                                        // ← LABEL
                        mMajLargeurLabel()                                // ← LABEL (le contrôle a sa taille finale)
                        if (typeof option.onLoad != 'undefined') option.onLoad()
                        if (typeof option.onContentReady != 'undefined') option.onContentReady()
                    }, 0)
                },
                change: function (editor, event) {
                    Me.isDirty = true
                    option.value = Me.mGetValue()
                    mMajVide()                                            // ← LABEL
                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value)
                }
            }
        });

        mRenderLabel()                                                    // ← LABEL

        // ← LABEL : survol (DevExtreme fonce la bordure au survol)
        container.off(".ctrlLabel")
            .on("mouseenter.ctrlLabel", function () { if (container.hasClass("dx-texteditor")) container.addClass("dx-state-hover") })
            .on("mouseleave.ctrlLabel", function () { container.removeClass("dx-state-hover") })
    }

    this.mAddValue = function (value) {
        var editor = emojiArreaInstance.editor;
        editor.focus();
    }

    this.mGetValue = function () {
        var value = $InputObjetEmoji.getText()
        if (value.length > 0 && value.charCodeAt(value.length - 1) > 255) value += "  "
        return value
    }
    this.mSetValue = function (value) {
        $InputObjetEmoji.setText(value)
        mMajVide()                                                        // ← LABEL
    }

    this.focus = function () { $InputObjetEmoji.setFocus() }

    this.element = function () { return container }

    mConstruit();
}